<ion-grid fixed>
  <ion-row>
    <ion-col>
      <ion-button type="submit" expand="block" (click)="openPayment()">
        {{
          realizedPayments.length !== 0
            ? "Renovar  suscripción"
            : "Pagar  suscripción"
        }}
      </ion-button>
    </ion-col>
  </ion-row>
</ion-grid>
<ng-container *ngIf="realizedPayments.length !== 0; else noList">
  <!-- <ion-grid class="table">
    <ion-row class="header">
      <ion-col class="col" size="4">Plan</ion-col>
      <ion-col class="col" size="4">Fecha de Pago</ion-col>
      <ion-col>Monto</ion-col>
    </ion-row>
    <ion-row *ngFor="let payment of realizedPayments; index as i">
      <ion-col class="col" size="4">{{ payment.plan_id.nombre }}</ion-col>
      <ion-col class="col" size="4">{{ payment.fecha_pago }}</ion-col>
      <ion-col>{{ payment.monto }}</ion-col>
    </ion-row>
  </ion-grid> -->

  <ion-list>
    <ion-list-header> <h3>Pagos registrados:</h3> </ion-list-header>
    <ion-item *ngFor="let payment of realizedPayments; index as i">
      <ion-label>
        <h2>Plan: {{ payment.plan_id.nombre }}</h2>
        <h3>
          Fecha de pago:
          {{
            payment.fixed
          }}
        </h3>
        <h3>Monto: {{ payment.monto }}</h3>
      </ion-label>
    </ion-item>
  </ion-list>
</ng-container>

<ng-template #noList>
  <ion-grid fixed>
    <ion-row>
      <ion-col size="12" *ngIf="!isLoading; else spinner">
        <ion-text class="ion-text-center">
          <h3>No hay pagos registrados</h3>
        </ion-text></ion-col
      >
      <ng-template #spinner>
        <ion-col
          size="12"
          style="display: flex; justify-content: center; align-items: center"
        >
          <ion-spinner></ion-spinner>
        </ion-col>
      </ng-template>
    </ion-row>
  </ion-grid>
</ng-template>
